<div class="contacts-container">
    <div class="contacts-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/mail_red.png" alt="users Icon" class="file-icon">
            <span class="header-title">
            <span class="title-text">{{archivedList ? 'Demandes de contact archivées ' : 'Demandes de contact' }} ( <span class="title-count">{{ totalCount }}</span> )</span>

            </span>
        </div>

        <div class="header-right">
            <button class="add-article-btn" (click)="getArchiveContact()">
                <img [src]="archivedList ? 'assets/images/icons/mail-default.png' : 'assets/images/icons/archive.png'" alt="file_check icon" class="add-icon">
                <span>{{archivedList ? 'Demandes de contact' : 'Archive' }}</span>
            </button>
        </div>
    </div>

    <div class="search-filter-row">
        <div class="search-container">
            <div class="search-input-group">
                <img src="assets/images/icons/input_search.png" alt="Search" class="search-icon">
                <input type="text" class="search-input" placeholder="Rechercher..." [(ngModel)]="searchTerm" (input)="onSearch()">
            </div>
        </div>
        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedVisibility" (change)="onFilterChange()">
                <option value="all">Tous</option>
                <option value="true">Lu</option>
                <option value="false">Non lu</option>
            </select>
        </div>

        <div class="filter-group">
            <select class="filter-select custom-select" [(ngModel)]="selectedSort" (change)="onSortChange()">
                <option value="" disabled>Trier par</option>
                <option value="createdAt,desc">Date (plus récent)</option>
                <option value="createdAt,asc">Date (plus ancien)</option>
                <option value="fullName,asc">Nom (A-Z)</option>
                <option value="fullName,desc">Nom (Z-A)</option>
            </select>
        </div>

        <!--<button class="filter-btn" (click)="toggleFilterPopup()">
            <img src="assets/images/icons/filter.png" alt="Filter" class="filter-icon">
            <span>Filtrer</span>
        </button>-->
    </div>

    <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Chargement des demandes de contact...</p>
    </div>

    <div *ngIf="!isLoading && contacts.length === 0" class="empty-state">
        <p>Aucune demande de contact trouvée</p>
    </div>

    <div *ngIf="!isLoading && contacts.length > 0" class="contacts-grid">
        <app-admin-contact-card *ngFor="let contact of contacts" [contact]="contact" (contactUpdated)="onContactUpdated()" (contactArchived)="onContactArchived()" (contactDeleted)="onContactDeleted()">
        </app-admin-contact-card>@if(totalPages>1){
        <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" (pageChange)="onPageChange($event)"></app-pagination>
        }
    </div>
</div>